// tslint:disable-next-line: eofline

export const CORE_PREFIX = 'core/';
export const CREATE_SHIPMENT_PREFIX = 'createShipment/';
export const UPLOAD_DOCUMENT_PREFIX = 'uploadDocument/';
export const HISTORY_PREFIX = 'history/';

export const ACTIONS = {
    CORE: {
        FETCH_NEWS: 'fetchNews',
        FETCH_COMPANY_ACCOUNTS: 'fetchCompanyAccounts',
        FETCH_COMPANY_ACCOUNTS_BY_COMPANYID: 'fetchCompanyAccountByCompanyId',
        FETCH_COUNTRIES: 'fetchCountries',
        FETCH_STATES: 'fetchStateCodes',
        FETCH_INCOTERMS: 'fetchIncoterms',
        FETCH_HEADER_DATA: 'fetchHeaderData',
        FETCH_USER_BRANCH: 'fetchUserBranch',
        FETCH_COMPANIES: 'fetchCompanies',
        FETCH_TRANSPORT_PRODUCTS: 'fetchTransportProducts',
        FETCH_EXPORT_REASON: 'fetchExportReasons',
        FETCH_CURRENCY: 'fetchCurrency',
        FETCH_DAILY_MANIFEST: 'fetchDailyManifest',
        SET_SHIPPING_SYSTEM: 'setShippingSystem',
        SET_NEWS_SHOWN_FOR_USER: 'setNewsShownForUser',
        SET_CUSTOMER_TRANSACTION_ID: 'setCustomerTransactionId',
        SET_LOADING: 'setLoading',
        SET_ACCOUNT: 'setAccount',
        CHANGE_COMPANY: 'changeCompany',
        INITIALIZE_CREATE_SHIPMENT: 'initializeCreateShipment',
        INITIALIZE_SYSTEM: 'initialize',
        INITIALIZE_USER: 'initializeUser',
        CHANGE_BOOKINGSYSTEM: 'changeBookingSystem',
        GET_USER: 'getUser',
        CREATE_DOCUMENT_PACK: 'createDocumentPack',
        FETCH_VISIBLE_BRANCHES_FOR_USER: 'fetchVisibleBranchesForUser',
        SET_TEST_USER: 'setTestUser',
        SET_SIGNALRCONNECTION: 'setSignalRConnection',
        FETCH_CUSTOMS_FREE_ZONES: 'fetchCustomsFreeZones',
        FETCH_SHIPMENT_SYSTEMS: 'fetchShipmentSystems'
    },

    CREATESHIPMENT: {
        GET_SHIPMENT_PRICE: 'getShipmentPrice',
        FETCH_SHIPMENT_PROTOTYPE: 'fetchShipmentPrototype',
        FETCH_ADDRESS_BOOK: 'fetchAddressbook',
        FETCH_DANGEROUS_GOODS_TYPES: 'fetchDangerousGoodsType',
        FETCH_DANGEROUS_GOODS_DESCRIPTIONS: 'fetchDangerousGoodsDescriptions',
        FETCH_PACKAGING_TYPES: 'fetchPackagingTypes',
        FETCH_BOOKING_OPTIONS: 'fetchBookingOptions',
        FETCH_DEFAULT_VALUES: 'fetchDefaultValues',
        FETCH_SHIPPING_OPTIONS: 'fetchShippingOptions',
        FETCH_COMPANY_ACCOUNT_ADDRESSES: 'fetchCompanyAccountAddresses',
        FETCH_SHIPMENTPACKAGING: 'fetchShipmentPackaging',
        FETCH_CUSTOMER_DESCRIPTIONS: 'fetchCustomerDescriptions',
        FETCH_REFERENCE_TYPES: 'fetchReferenceTypes',
        FETCH_POSTAL_CODES: 'fetchPostalCodes',

        RELOAD_CREATE_SHIPMENT: 'reloadCreateShipment',
        SELECT_SHIPPING_OPTION_PRODUCT: 'selectShippingOptionProduct',
        CLEAR_SELECT_SHIPPING_OPTION_PRODUCT: 'clearSelectShippingOptionProduct',
        CLEAR_SHOW_SHIPPING_OPTIONS: 'clearShowShippingOptions',
        CREATE_SHIPMENT: 'createShipment',

        SET_SELECTED_COMPANYID: 'setSelectedCompanyId',
        SET_PROTOTYPE: 'setPrototype',
        SET_PRICE_EXPANDED: 'setPriceExpanded',

        SET_BACKENDERROR: 'setBackendError',
        SET_ISCOLLIDEMENSIONS: 'SetIsColliDemensions',
        SET_ISDANGEROUSGOODS: 'setIsDangerousGoods',
        SET_INSURANCEAMOUNT_REQUIRED: 'setInsuranceAmount',
        SET_SERVICE_PRICES: 'setServicePrices',
        CHANGE_ISRECEIVERPAYS: 'changeIsReceiverPays',
        CLEAR_BACKENDERRORS: 'clearBackendErrors',
        GETSHIPMENTDATA: 'getShipmentData',
        GETSHIPMENTDATABYLINKID: 'getShipmentDataByLinkId',
        GETSHOTFILESHIPMENTDATA: 'getShotFileShipmentData',
        DELETE_ADDRESS: 'deleteAddress',
        UPDATE_ADDRESS: 'updateAddress',
        CREATE_ADDRESS: 'createAddress',
        REQUEST_QUOTE: 'requestQuote',

        UPSERT_SHIPMENTPACKAGING: 'upsertShipmentPackaging',
        DELETE_SHIPMENTPACKAGING: 'deleteShipmentPackaging',
        GET_VIEW_OPTIONS: 'getViewOptions'
    },

    HISTORY: {
        INITIALIZE_HISTORY: 'initializeHistory',
        FETCH_SHIPMENT_DIRECTION: 'fetchShipmentDirection',
        FETCH_INTERNAL_MESSAGES: 'fetchInternalMessages',
        FETCH_EMAIL_TEMPLATES: 'fetchEmailTemplates',
        FETCH_PRICE_LINE_TYPES: 'fetchPriceLineTypes',
        FETCH_SEARCH_OPTIONS: 'fetchSearchOptions',
        FETCH_COMPANY_ACCOUNTS: 'fetchCompanyAccounts',
        FETCH_ALL_COMPANY_ACCOUNTS: 'fetchAllCompanyAccounts',
        FETCH_DELIVERY_STATUSES: 'fetchDeliveryStatuses',
        FETCH_SALES_PRODUCTS: 'fetchSalesProducts',
        FETCH_SALES_PRODUCTS_BY_COMPANYID: 'fetchSalesProductsByCompanyId',
        FETCH_SALES_PRODUCTS_BY_ACCOUNTID: 'fetchSalesProductsByAccountId',
        FETCH_TRANSPORT_COMPANIES: 'fetchTransportCompanies',
        FETCH_HISTORY_SHIPMENTS: 'fetchHistoryShipments',
        FETCH_HISTORY_SHIPMENT_INFO: 'fetchHistoryShipmentInfo',
        UPDATE_SENDER_RECEIVER_REFERENCE: 'updateSenderReceiverReference',
        UPDATE_TRACKING_LINK: 'updateTrackingLink',
        UPDATE_TRANSIT_STATUS: 'updateTransitStatus',
        SET_INTERNAL_MESSAGE: 'setInternalMessage',
        UPDATE_SHIP_DATE: 'updateShipDate',
        UPDATE_EXPECTED_DELIVERY_DATE: 'updateExpectedDeliveryDate',
        UPDATE_SHIP_AWB: 'updateShipAWB',
        SEND_EMAIL_TEMPLATE: 'sendEmailTemplate',
        ADD_PRICE_LINES: 'addPriceLines',
        SET_SELECTED_ROWS: 'setSelectedRows',
        FETCH_LABELS: 'fetchLabels',
        FETCH_LABEL: 'fetchLabel',
        FETCH_MANIFEST: 'fetchManifest',
        FETCH_CSV: 'fetchCsv',
        FETCH_LABEL_AND_DOCUMENTS_WITHOUT_CONNOTE: 'fetchLabelAndDocumentsWithoutConnote',
        FETCH_LABEL_AND_DOCUMENTS: 'fetchLabelAndDocuments',
        UPDATE_DELIVERY_STATUS: 'updateDeliveryStatus',
        DELETE_DOCUMENTS: 'deleteDocuments',
        FETCH_INVOICE: 'fetchInvoice',
        GET_INVOICE_DATA: 'getInvoiceData',
        CREATE_INVOICE: 'createInvoice',
        DELETE_SHIPMENTS: 'deleteShipments',
        TRANSFER_SHIPMENT: 'transferShipment',
        TRANSFER_SHIPMENTS: 'transferShipments',
        SET_FILTER: 'setFilter',
        RESTORE_SHIPMENTS: 'restoreShipments',
        CHANGE_SHIPMENTS_ACCOUNT: 'changeShipmentsAccount',
        FETCH_DOCUMENT_PACK: 'fetchDocumentPack',
        FETCH_PRICE_LINES: "fetchPriceLines",
        TRANSFER_SHIPMENT_INVOICING: "transferShipmentsToInvoicing"
    },

    UPLOAD_DOCUMENT: {
        FETCH_SHIPMENT_DOCUMENT_TYPES: 'fetchShipmentDocumentTypes',
        POST_UPLOAD_DOCUMENT: 'postUploadDocument',
        POST_UPLOAD_DOCUMENT2: 'postUploadDocument2'
    }
};

export const GETTERS = {
    CREATE_SHIPMENT: {
        HAS_SHIPPINGOPTIONS: 'hasShipmentOptions',
        SHIPMENTPACKAGING: 'GetShipmentPackagings',
        SHIPMENTPACKAGING_ACTIVE: 'shipmentPackagingActive',
        PACKAGINGID_BY_TYPE: 'getPackagingIdByTypeName',
        GET_SERVICE_PRICES: 'getServicePrices',
        GET_PROTOTYPE: 'getPrototype',
        IS_EDIT_ADDRESS: 'isEditAddress',
        BLOCKED_DESCRIPTIONS: 'blockedDescriptions'
    },
    CORE: {
        IS_US_SYSTEM: 'isUSSystem'
    },

    HISTORY: {
        GET_FILTER: 'getFilter'
    }
};

export const MUTATIONS = {
    CORE: {
        SET_SHIPPING_SYSTEM: 'setShippingSystem',
        SET_NEWS: 'setNews',
        SET_USER_DATA: 'setUserData',
        SET_USER_BRANCH: 'setUserBranch',
        SET_HEADER_DATA: 'setHeaderData',
        SET_INCOTERMS: 'setIncoTerms',
        SET_USER_DEFAULT_ACCOUNT: 'setUserDefaultAccount',
        SET_COUNTRIES: 'setCountries',
        SET_STATECODES: 'setStateCodes',
        SET_LOADING: 'setLoading',
        SET_COMPANIES: 'setCompanies',
        SET_SHIPPING_LABEL: 'setShippingLabel',
        SET_CUSTOMER_TRANSACTION_ID: 'setCustomerTransactionId',
        SET_ACCOUNT: 'setAccount',
        SET_SHIPMENT_ID: 'setShipmentId',
        SET_LINK_ID: 'setLinkId',
        SET_COMPANY_ACCOUNTS: 'setCompanyAccounts',
        SET_TRANSPORT_PRODUCTS: 'setTransportProducts',
        SET_EXPORT_REASON: 'setExportReason',
        SET_CURRENCY: 'setCurrency',
        SET_INITIALIZED: 'setInitialized',
        SET_VISIBLE_BRANCHES_FOR_USER: 'setVisibleBranchesForUser',
        SET_TEST_USER: 'setTestUser',
        SET_CUSTOMS_FREE_ZONES: 'setCustomsFreeZones',
        SET_SHIPMENT_SYSTEMS: 'setShipmentSystems'
    },

    CREATESHIPMENT: {
        SET_COMPANY_ACCOUNT_ADDRESSES: 'setCompanyAccountAddresses',
        SET_PROTOTYPE_SHIPMENT: 'setPrototypeShipment',
        SET_ADDRESS_BOOK: 'setAddressbook',
        SET_EXPORT_REASON: 'setExportReason',
        SET_SHIP_DATE: 'setShipDate',
        SET_DANGEROUS_GOODS_TYPES: 'setDangerousGoodsType',
        SET_DANGEROUS_GOODS_DESCRIPTIONS: 'setDangerousGoodsDescriptions',
        SET_PACKAGING_TYPES: 'setPackagingTypes',
        SET_BACKENDERROR: 'setBackendError',
        SET_BACKENDERROR_TECHNICAL: 'setBackendTechnical',
        SET_ISCOLLIDEMENSIONS: 'SetIsColliDemensions',
        SET_ISDANGEROUSGOODS: 'setIsDangerousGoods',
        SET_SELECTED_COMPANYID: 'setSelectedCompanyId',
        SET_BOOKING_OPTIONS: 'setBookingOptions',
        SET_DEFAULT_VALUES: 'setDefaultValues',
        SET_SHIPPING_OPTIONS: 'setShippingOptions',
        SET_SHIPMENT: 'setShipment',
        CLEAR_SHOW_SHIPPING_OPTIONS: 'clearShowShippingOptions',
        SHIPMENT_CREATED: 'shipmentCreated',
        CLEAR_BACKENDERRORS: 'clearBackendErrors',
        SET_PRICE_EXPANDED: 'setPriceExpanded',

        SELECT_SHIPPING_OPTION_PRODUCT: 'selectShippingOptionProduct',
        CLEAR_SELECT_SHIPPING_OPTION_PRODUCT: 'clearSelectShippingOptionProduct',
        SET_INSURANCEAMOUNT_REQUIRED: 'setInsuranceAmountRequired',
        CHANGE_ISRECEIVERPAYS: 'changeIsReceiverPays',
        SET_TRANSITTIMES: 'setTransitTimes',
        SET_SERVICE_PRICES: 'setServicePrices',
        SET_SHIPMENTPACKAGING: 'setShipmentPackaging',
        SET_CUSTOMER_DESCRIPTIONS: 'setCustomerDescriptions',
        SET_REFERENCE_TYPES: 'setReferenceTypes',
        SET_INITIALIZED: 'setInitialized',
        
        UPSERT_SHIPMENTPACKAGING: 'upsertShipmentPackage',
        DELETE_SHIPMENTPACKAGING: 'deleteShipmentPackaging',
    },

    HISTORY: {
        SET_SHIPMENT_DIRECTION: 'setShipmentDirection',
        SET_SEARCH_OPTIONS: 'setSearchOptions',
        SET_DELIVERY_STATUSES: 'setDeliveryStatuses',
        SET_SALES_PRODUCTS: 'setSalesProducts',
        SET_TRANSPORT_COMPANIES: 'setTransportCompanies',
        SET_COMPANY_ACCOUNTS: 'setCompanyAccounts',
        SET_SELECTED_ROWS: 'setSelectedRows',
        SET_SHIPMENTS: 'setShipments',
        DELETE_SHIPMENTS: 'deleteShipments',
        TRANSFER_SHIPMENTS: 'transferShipments',
        SET_FILTER: 'setFilter',
        RESTORE_SHIPMENTS: 'restoreShipments',
        SET_COUNTRIES: 'setCountries'
    },

    UPLOAD_DOCUMENT: {
        SET_SHIPMENT_DOCUMENT_TYPES: 'setShipmentDocumentTypes',
        SET_UPLOAD_RESPONSE: 'setUploadResponse'
    }
};
